import { render, staticRenderFns } from "./MeasureShow.vue?vue&type=template&id=2a635f8a&"
import script from "./MeasureShow.vue?vue&type=script&lang=js&"
export * from "./MeasureShow.vue?vue&type=script&lang=js&"
import style0 from "./MeasureShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MeasureShow.vue"
export default component.exports